import React, { useEffect, useMemo, useState } from 'react'
import "./style.css"
import { Breadcrumb, Title, UploadImageModal, SuccessPopupModal, PopUpModal } from '../../Components/Atoms'
import { VehicleMap } from '../../Components/Molecules';
import { DATASET_COLORS } from '../../Assets/styles/colors';
import StatCard from '../../Components/Molecules/StatCard';
import { secondsToHms } from '../../Library/datetime';

import { getDriverOrVehicleStats, getDriversInfo, updateDriverProfilePicture, removeDriverProfilePicture } from "../../APIs";
import { generateDatasetForDays } from '../../Library/widgets';

import { Loader } from "../../Pages";

import PATHS from "../../Routes/paths";
import { useNavigate } from 'react-router-dom';
import { CameraIcon } from '../../Assets/images/svgs';
import { Button, Menu, MenuButton, MenuList, MenuItem, useToast } from '@chakra-ui/react';

const DriverStats = () => {
  const navigate = useNavigate();
  const Toast = useToast();

  const [ driverDetails, setDriverDetails ] = useState({});

  const [ driverStats, setDriverStats ] = useState([]);

  const [ avgDistanceStats, setAvgDistanceStats ] = useState({});
  const [ avgTimeStats, setAvgTimeStats ] = useState({});
  const [ avSpeedStats, setAvsSpeedStats ] = useState({});

  const [ showLoading, setShowLoading ] = useState(true);

  const [ vid, setVid ] = useState({});

  const [ showUploadModal, setShowUploadModal ] = useState(false);
  const [ showUploadingLoader, setShowUploadingLoader ] = useState(false);

  const [ showConfirmationModal, setShowConfirmationModal ] = useState(false);

  let graphCards = [];

  const breadcrumbPaths = [
    { idx: 1, name: "Drivers", link: `${PATHS.LEASE}/${PATHS.DRIVERS}` },
    { idx: 2, name: `${driverDetails.dNm}`, link: "", isCurrentPage: true },
  ];

  const distParser = { x: "label", y: "count", yUnit: "km", yLabel: "Average Distance / Day", xLabel: "Days" };
  const timeParser = { x: "label", y: "count", yUnit: "hrs", yLabel: "Average Time / Day", xLabel: "Days" };
  const speedParser = { x: "label", y: "count", yUnit: "km/hr", yLabel: "Average Speed / Day", xLabel: "Days" };

  const axisStyles = {
    x: {
      title: { color: "#FFFFFF33", font: { size: "13px", weight: 400 }, padding: { top: 14 } },
      ticks: { autoSkip: false, maxRotation: 90 },
    },
    y: {
      title: { color: "#FFFFFF33", font: { size: "13px", weight: 400 }, padding: { bottom: 14 } },
    },
  };

  const fetchDriverDetails = (driverId) => {
    getDriversInfo(null, driverId, null, null, (err, resp) => {
      if (err) console.log(err);
      else {
        if (resp && resp.length) {
          setDriverDetails(resp[0]);
          setVid(resp[0].vid);
        }
      }
    });
  }

  const getDriverStats = (drId) => {
    getDriverOrVehicleStats(null, drId, null, (err, resp) => {
      if (err) {
        console.log(err);
        setShowLoading(false);
      } else {
        setDriverStats(resp.dayWiseStats);
        setAvgDistanceStats({ lifeTimeDist: resp.overallStats.totalDst });
        setAvgTimeStats({ lifeTime: resp.overallStats.totalDur });
        setAvsSpeedStats({ lifeTimeTopSpeed: resp.overallStats.tps });

        setShowLoading(false);
      }
    })
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const driver = queryParams.get('idx');

    if (!driver) navigate(`${PATHS.LEASE}/${PATHS.DRIVERS}`)

    fetchDriverDetails(driver);
    getDriverStats(driver);
  }, [ navigate ])

  // const GetAssignVehicleButton = ({ vehicle, registration }) => {
  //   return (
  //     <span>
  //       {!!vehicle ? registration : "Not Assigned"} <br />
  //       <Button onClick={() => navigate("/lease/vehicles/lease-vehicles")} className='assign-vehicle'>{!!vehicle ? "Unassign" : "Assign"} vehicle</Button>
  //     </span>
  //   )
  // }

  const driverDetailsLeft = [
    { label: "Driver Name", value: driverDetails.dNm },
    { label: "Driving License", value: driverDetails.dl },
    { label: "Driver ID", value: driverDetails.idx },
  ]

  const driverDetailsRight = [
    { label: "Contact Number", value: driverDetails.mob },
    { label: "Aadhar Number", value: driverDetails.adhrNum },
    { label: "Vehicle Assigned", value: driverDetails.vreg || "Not Assigned" },
  ]

  const driverDetailsNewRight = [
    { label: "Amount Outstanding", value: driverDetails.outsdAmt?.toLocaleString() },
  ]

  const distanceStats = useMemo(() => {
    const distanceData = driverStats || [];

    let [ dataset, total, average ] = generateDatasetForDays(30, distanceData, "dst", 1000, DATASET_COLORS.ORANGE);
    setAvgDistanceStats(old => ({ ...old,  avDist: (average / 1000), totalDist: (total / 1000) }))

    return dataset;
  }, [ driverStats ]);

  const timeStats = useMemo(() => {
    const timeData = driverStats || [];

    let [ dataset, total, average ] = generateDatasetForDays(30, timeData, "dur", 60 * 60, DATASET_COLORS.SUCCESS);
    setAvgTimeStats(old =>  ({ ...old, avTime: (average / (60 * 60)), totalTime: total / (60 * 60) }))
    return dataset;
  }, [ driverStats ]);

  const speedStats = useMemo(() => {
    const speedData = driverStats || [];

    let [ dataset, total, average, points ] = generateDatasetForDays(30, speedData, "avs", 1, DATASET_COLORS.CYAN);
    let topSpeed = Math.max(...points.map(({ tps }) => tps));
    if (!isFinite(topSpeed)) topSpeed = 0;

    setAvsSpeedStats(old =>  ({ ...old, avSpeed: (average), totalSpeed: total, topSpeed: topSpeed }))
    return dataset;
  }, [ driverStats ]);

  if (distanceStats && timeStats && speedStats) {
    graphCards = [
      {
        title: "Distance Travelled",
        averageStats: {
          labelFirst: {
            label: "Average Distance / Day",
            value: `${avgDistanceStats.avDist ? Math.floor(avgDistanceStats.avDist).toLocaleString() : 0}km`,
          },
          labelSecond: {
            label: "Total Distance (Last 30 days)",
            value: `${avgDistanceStats.totalDist ? Math.floor(avgDistanceStats.totalDist).toLocaleString() : 0}km`,
          },
          labelThird: {
            label: "Total Distance (Lifetime)",
            value: `${avgDistanceStats.totalDist ? Math.floor(avgDistanceStats.totalDist).toLocaleString() : 0}km`,
          },
        },
        parser: distParser,
        stats: distanceStats,
        axisStyles: axisStyles,
        formatter: (distance) => `${Number(distance).toFixed(2)} km`,
      },
      {
        title: "Time Travelled",
        averageStats: {
          labelFirst: {
            label: "Average Time / Day",
            value: secondsToHms(avgTimeStats.avTime * 60 * 60),
          },
          labelSecond: {
            label: "Total Time (Last 30 days)",
            value: secondsToHms(avgTimeStats.totalTime * 60 * 60),
          },
          labelThird: {
            label: "Total Time (Lifetime)",
            value: secondsToHms(avgTimeStats.totalTime * 60 * 60),
          },
        },
        parser: timeParser,
        stats: timeStats,
        axisStyles: axisStyles,
        formatter: (duration) => secondsToHms(duration * 60 * 60),
      },
      {
        title: "Speed",
        averageStats: {
          labelFirst: {
            label: "Average Speed",
            value: `${avSpeedStats.avSpeed ? Math.floor(avSpeedStats.avSpeed).toLocaleString() : 0}km/hr`,
          },
          labelSecond: {
            label: "Top Speed (Last 30 days)",
            value: `${avSpeedStats.topSpeed ? Math.floor(avSpeedStats.topSpeed).toLocaleString() : 0}km/hr`,
          },
          labelThird: {
            label: "Top Speed (Lifetime)",
            value: `${avSpeedStats.lifeTimeTopSpeed ? Math.floor(avSpeedStats.lifeTimeTopSpeed).toLocaleString() : 0}km/hr`,
          },
        },
        parser: speedParser,
        stats: speedStats,
        axisStyles: axisStyles,
        formatter: (speed) => `${Number(speed).toFixed(2)} km/hr`,
      },
    ];
  }

  const getInitials = (string = "") => {
    let words = string.split(" ");

    return words.map(word => word.slice(0, 1).toUpperCase());
  }

  const updateProfilePicture = async (profileImage) => {
    setShowUploadingLoader(true);
    try {
      await updateDriverProfilePicture({ drId: driverDetails.idx }, [ profileImage ]);
      setDriverDetails({ ...driverDetails, profImg: URL.createObjectURL(profileImage) });
      setShowUploadModal(false);
    } catch(error) {
      Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
      console.error(error);
    } finally {
      setShowUploadingLoader(false);
    }
  }

  const removeProfilePicture = async () => {
    try {
      await removeDriverProfilePicture({ drId: driverDetails.idx });
      setDriverDetails({ ...driverDetails, profImg: null });
    } catch (error) {
      Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
      console.error(error);
    } finally {
      setShowConfirmationModal(null);
    }
  }

  const handleConfirmation = () => {
    setShowConfirmationModal({
      open: true,
      modalMsg: "Are you sure you want to remove the profile picture for this driver?",
      closeBtn: "Cancel",
      confirmBtn: "Yes",
      onConfirm: () => removeProfilePicture(),
      onModalClose: () => setShowConfirmationModal(null),
    })
  }

  return (
    <>
      {!showLoading ?
        <div className='panel-main driver-page'>
          <header>
            <Breadcrumb paths={breadcrumbPaths} />
          </header>

          <div className="driver-stats-container">
            <div className="driver-profile">
              <Menu>
                <MenuButton as={Button} className="driver-profile-overlay">
                  <CameraIcon className="camera-icon" />
                </MenuButton>
                <MenuList style={{ marginTop: "-30px" }} className="update-picture-menu">
                  {!driverDetails.profImg
                    ? <MenuItem onClick={() => setShowUploadModal(true)} className="update-picture-menu-option">Add Profile Photo</MenuItem>
                    : <>
                        <MenuItem onClick={() => setShowUploadModal(true)} className="update-picture-menu-option">Change Profile Photo</MenuItem>
                        <MenuItem onClick={handleConfirmation} className="update-picture-menu-option">Remove</MenuItem>
                      </>
                  }
                </MenuList>
              </Menu>

              <div className="driver-image">
                {driverDetails.profImg ?
                  <img src={(driverDetails && driverDetails.profImg) ? driverDetails.profImg : ""} alt="" /> : getInitials(driverDetails.dNm)}
              </div>

              <div className="driver-details">
                <Title> Driver Details </Title>
                <div className="driver-details-wrapper">
                  <div className="driver-details-left">
                    {driverDetailsLeft.map((data, idx) => (
                      <label key={idx}>
                        { data.label }
                        <p>{ data.value || "N/A" }</p>
                      </label>
                    ))}
                  </div>
                  <div className="driver-details-right">
                    {driverDetailsRight.map((data, idx) => (
                      <label key={idx}>
                        { data.label }
                        <p>{ data.value || "N/A" }</p>
                      </label>
                    ))}
                  </div>
                  <div className="driver-details-new-right">
                    {driverDetailsNewRight.map((data, idx) => (
                      <label key={idx}>
                        { data.label }
                        <p>₹{ data.value || "0" }</p>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="driver-detail-map-container">
              { vid ? <VehicleMap vids={[vid]} /> : <p className="no-map">No Vehicle Assigned</p>}
            </div>

            { (graphCards && graphCards.length) ? graphCards.map((card, idx) => <StatCard key={idx} card={card} />) : null}
          </div>

          <UploadImageModal
            show={showUploadModal}
            onSubmit={updateProfilePicture}
            onCancel={() => setShowUploadModal(false)}
            existingProfileImage={driverDetails.profImg}
            showUploading={showUploadingLoader}
          />

          <PopUpModal { ...showConfirmationModal } />
        </div>
      : <Loader hide={true} />}
    </>
  )
}

export default DriverStats
